export const inputs = {
  primary: "Explore",
  teacher: "Become a Teacher",
  login: "Login",
  search: "what do you want to learn?",
  //Trial: "Book a Free Trial Lesson",
};
